import { ImageUrlPipe } from "./image-url";

export const pipes = [ImageUrlPipe];

export { ImageUrlPipe };
